import { useState } from 'react'
import './IPRModal.css'

const IPRModal = ({ talent, isOpen, onClose, onSubmit, loading }) => {
  const [feedback, setFeedback] = useState('')

  if (!isOpen) return null

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(feedback)
  }

  return (
    <div className="ipr-modal-overlay">
      <div className="ipr-modal">
        <div className="ipr-modal-header">
          <h3>Создание индивидуального плана развития</h3>
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="ipr-modal-body">
          <div className="talent-info">
            <h4>{talent.name}</h4>
            <p className="talent-role">{talent.role}</p>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="feedback">
                Опишите ваши цели и пожелания по развитию этого таланта:
              </label>
              <textarea
                id="feedback"
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                placeholder="Например: Хочу развить навыки публичных выступлений, научиться эффективно структурировать презентации и уверенно отвечать на вопросы аудитории..."
                rows={5}
              />
              <p className="input-hint">
                Ваши пожелания помогут ИИ создать более персонализированный план развития.
              </p>
            </div>

            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={onClose} disabled={loading}>
                Отмена
              </button>
              <button type="submit" className="btn-primary" disabled={loading || !feedback.trim()}>
                {loading ? (
                  <>
                    <span className="loading-spinner"></span>
                    Создание плана...
                  </>
                ) : (
                  'Создать план'
                )}
              </button>
            </div>
            {loading && (
              <div className="loading-message">
                <p>Идет создание индивидуального плана развития с помощью ИИ.</p>
                <p>Это может занять 10-20 секунд...</p>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  )
}

export default IPRModal
